import { render, staticRenderFns } from "./UserBreakdown.vue?vue&type=template&id=24ce6b88&scoped=true&"
import script from "./UserBreakdown.vue?vue&type=script&lang=js&"
export * from "./UserBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./UserBreakdown.vue?vue&type=style&index=0&id=24ce6b88&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ce6b88",
  null
  
)

export default component.exports